import PropTypes from 'prop-types';

const vehiclePropType = PropTypes.shape({
  carNumber: PropTypes.string.isRequired,
  brand: PropTypes.string,
  model: PropTypes.string,
});

export default vehiclePropType;
